import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row className="home-row">
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
                Hi Everyone, I am Hichem LAOUAR from France.
                I am a FULL STACK Developper.
      
              <br />
              <br />
              My field of Interest's is 
              <b className="purple"> Web Developement </b> by
               building new &nbsp;
              <i>
                <b className="purple">Web Application and Solutions </b> 
                Actuely i'am a FullStack Web Developer at 
                <b className="purple">
                  <a href="https://www.engie.fr/" target="_blank"> Engie</a>
                </b>
                , So Development of a portal for processing the processes of
                collection, control and filing of CEE files (ccertificat
                d'économie d'énergie) for the residential and tertiary sector
                of Engie (
                  <b className="purple">
                  <a href="https://swappcee.engie.fr/" target="_blank">SwappCee</a>
                </b>
                ).
              </i>
              <br />
              <br />
            </p>
          </Col>
        
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/hichemCodes"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/hichem-laouar/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
